'use client';

import React from 'react';
import { ChevronLeft, ChevronRight } from '../icons';

interface IYearPickerProps {
  year: number;
  increment: () => void;
  decrement: () => void;
}

export const YearPicker = ({ year, increment, decrement }: IYearPickerProps) => (
  <div className="flex flex-row gap-3 justify-between items-center">
    <button onClick={decrement}>
      <ChevronLeft />
    </button>
    <span>{year}</span>
    <button onClick={increment}>
      <ChevronRight />
    </button>
  </div>
);
